import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

const parseStringToDate = (
  value: string | undefined | null,
  t: (key: string) => string,
  longFormat: boolean = true
) => {
  if (value !== undefined && value !== null) {
    dayjs.extend(customParseFormat);

    const date = dayjs(value, t('date.apiFormat'));

    if (longFormat) {
      return date.format(t('date.long'));
    }

    return date.format(t('date.shortDayJS'));
  }

  return null;
};

const resolveDate = (days: number | undefined) => {
  const date = new Date();
  date.setDate(date.getDate() + (days ?? 0));

  return date;
};

export { parseStringToDate, resolveDate };
